import type { IconProps } from '@omnipresentgroup/design-system';
import { TimesheetArbeitszeitTimeSlotTypeEnum } from '@omnipresentgroup/types';

export const MAX_TOTAL_HOURS_PER_WEEK = 40;

export const TIMESLOT_TYPES_CONFIG = new Map<
  TimesheetArbeitszeitTimeSlotTypeEnum,
  {
    icon: IconProps['icon'];
    label: string;
  }
>([
  [
    TimesheetArbeitszeitTimeSlotTypeEnum.WORK,
    {
      icon: 'Briefcase',
      label: 'Work',
    },
  ],
  [
    TimesheetArbeitszeitTimeSlotTypeEnum.BREAK,
    {
      icon: 'Coffee',
      label: 'Break',
    },
  ],
  [
    TimesheetArbeitszeitTimeSlotTypeEnum.SICK,
    {
      icon: 'Bandage',
      label: 'Sick',
    },
  ],
  [
    TimesheetArbeitszeitTimeSlotTypeEnum.OVERTIME,
    {
      icon: 'ClockPlus',
      label: 'Overtime',
    },
  ],
  [
    TimesheetArbeitszeitTimeSlotTypeEnum.VACATION,
    {
      icon: 'Beach',
      label: 'Vacation',
    },
  ],
  [
    TimesheetArbeitszeitTimeSlotTypeEnum.PUBLIC_HOLIDAY,
    {
      icon: 'CalendarOff',
      label: 'Public holiday',
    },
  ],
  [
    TimesheetArbeitszeitTimeSlotTypeEnum.PARENTAL_LEAVE,
    {
      icon: 'BabyCarriage',
      label: 'Parental leave',
    },
  ],
]);
